import { Component, Input, Output, EventEmitter, OnInit, OnChanges, SimpleChanges } from '@angular/core';

import { TranslateModule } from '@ngx-translate/core';
import { UseCasesService } from '../../services/use-cases.service';
import { UseCase } from '../../models/use-case.model';
import { PaginatedSectionBase } from '../shared/paginated-section.base';
import { SectionShellComponent } from '../shared/section-shell/section-shell.component';
import { DemoFilters, defaultDemoFilters } from '../../models/demo-filters.model';

@Component({
    selector: 'app-use-cases',
  imports: [TranslateModule, SectionShellComponent],
    templateUrl: './use-cases.component.html',
    styleUrl: './use-cases.component.scss'
})
export class UseCasesComponent extends PaginatedSectionBase<UseCase> implements OnInit, OnChanges {
  @Input() selectedSolutions: string[] = [];
  @Input() filters: DemoFilters = defaultDemoFilters();
  @Input() bookmarkedIds: number[] = [];
  @Output() bookmarkToggle = new EventEmitter<number>();
  
  private allUseCases: UseCase[] = [];

  constructor(private readonly useCasesService: UseCasesService) {
    super();
  }

  ngOnInit(): void {
    this.useCasesService.getUseCases().subscribe({
      next: (useCases) => {
        this.allUseCases = useCases;
        this.filterUseCases();
      },
      error: (error) => {
        console.error('Error loading use cases:', error);
      }
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['selectedSolutions'] || changes['filters']) {
      this.filterUseCases();
    }
  }

  private filterUseCases(): void {
    let useCases = this.allUseCases.slice();

    if (this.selectedSolutions.length) {
      useCases = useCases.filter(uc => uc.solutions?.some(s => this.selectedSolutions.includes(s)));
    }

    const { searchText, product, industry, discipline, material } = this.filters;
    const q = searchText.trim().toLowerCase();

    useCases = useCases.filter(uc => {
      if (q && !uc.title.toLowerCase().includes(q) && !(uc.description?.toLowerCase().includes(q) ?? false)) return false;
      if (product.length && !product.some(p => uc.solutions?.includes(p))) return false;
      if (industry.length && !industry.some(i => uc.industry?.includes(i))) return false;
      if (discipline.length && !discipline.some(dis => uc.discipline?.includes(dis))) return false;
      if (material.length && !material.some(m => uc.material?.includes(m))) return false;
      return true;
    });

    this.setFilteredItems(useCases);
  }

  get visibleUseCases(): UseCase[] {
    return this.visibleItems;
  }

  readMore(useCase: UseCase): void {
    window.open(useCase.articleUrl, '_blank');
  }
}
